/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legendWideControlGroup{margin:0 0 5px}.legendWideControlGroup label{margin-top:4px;font-weight:700}.color-swatch{display:inline-block;width:60%;height:30px;border:1px solid #a9a9a9}.color-swatch:hover{border:1px solid #000;cursor:pointer}.color-picker .sketch-picker{width:200px}.cancel-button{margin:7px 7px 0 0}.cancel-button:hover{cursor:pointer}.symbol-editor label{margin-bottom:8px}"];
export { styles as styles };
